import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  const handleLogin = () => {
    localStorage.setItem("isLoggedIn", "true");
    navigate("/dashboard/search");
  };

  return (
    <div style={styles.wrapper}>
      
      {/* LEFT SIDE (PURPLE) */}
      <div style={styles.left}>
        <h1 style={styles.heading}>
          Welcome to <br />
          <span>student directory</span>
        </h1>

        <p style={styles.desc}>
          Login to access your student information.
        </p>
      </div>

      {/* RIGHT SIDE (LOGIN) */}
      <div style={styles.right}>
        <h1 style={styles.title}>Login</h1>
        <p style={styles.subtitle}>Enter your details</p>

        <input style={styles.input} placeholder="Username" />
        <input style={styles.input} type="password" placeholder="Password" />

        <p style={styles.forgot}>Forgot Password?</p>

        <button
          style={styles.button}
          type="button"
          onClick={handleLogin}
        >
          Login
        </button>

        {/* ✅ ADDED SIGN UP LINK */}
        <p
          style={{ marginTop: "10px", cursor: "pointer", color: "#9ca3af" }}
          onClick={() => navigate("/register")}
        >
          Don’t have an account? Sign up
        </p>
      </div>

    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    minHeight: "100vh",
    fontFamily: "Arial",
  },

  left: {
    flex: 1,
    background: "linear-gradient(135deg, #7c3aed, #a855f7)",
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "60px",
    clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
    position: "relative",
    zIndex: 1,
  },

  heading: {
    fontSize: "38px",
    marginBottom: "10px",
  },

  desc: {
    opacity: 0.9,
    marginBottom: "30px",
    maxWidth: "400px",
  },

  right: {
    flex: 1,
    background: "#111827",
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "60px",
    position: "relative",
    zIndex: 2,
  },

  title: {
    fontSize: "28px",
  },

  subtitle: {
    color: "#9ca3af",
    marginBottom: "30px",
  },

  input: {
    padding: "12px",
    marginBottom: "15px",
    borderRadius: "6px",
    border: "none",
    outline: "none",
  },

  forgot: {
    fontSize: "12px",
    color: "#9ca3af",
    marginBottom: "20px",
  },

  button: {
    padding: "12px",
    background: "#7c3aed",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default Home;